export default "__VITE_ASSET__ZjR8VTY___"